import { Config, Data } from "@measured/puck";

import { Image } from "./blocks/Image";
import { HeroSection, HeroSectionProps } from "./blocks/HeroSection";
import { ArticlesSection, ArticlesSectionProps } from "./blocks/ArticlesSection";
import { IndicatorsSection, IndicatorsSectionProps } from "./blocks/IndicatorsSection";
import { Typography } from "./blocks/Typography";
import { Separator, SeparatorProps } from "./blocks/Separator";
import { Space, SpaceProps } from "./blocks/Space";
import { Grid, GridBlockProps } from "./blocks/Grid";
import ScoreChartBlock, { ScoreChartBlockConfigProps } from "./blocks/ScoreChartBlock";
import ActionPlanBlock from "./blocks/ActionPlan";
import GreetingsConfig, { GreetingsProps } from "./blocks/Greetings";
import { ImageProps } from "./blocks/Image/types";
import { TypographyProps } from "./blocks/Typography/Typography";
import { ActionPlanConfigProps } from "./blocks/ActionPlan";
import Root, { RootProps } from "./root";

import { MainContentLayout } from "src/components/Layout/MainContentLayout";

export type Props = {
    Image: ImageProps;
    Typography: TypographyProps;
    HeroSection: HeroSectionProps;
    ArticlesSection: ArticlesSectionProps;
    IndicatorsSection: IndicatorsSectionProps;
    Separator: SeparatorProps;
    Space: SpaceProps;
    Grid: GridBlockProps;
    ScoreChartBlock: ScoreChartBlockConfigProps;
    ActionPlan: ActionPlanConfigProps;
    Greetings: GreetingsProps;
};

export type PageConfig = Config<Props, RootProps, "layout" | "media" | "content" | "interactive" | "data">;

export type PageData = Data<Props, RootProps>;

export const rootConfig: PageConfig = {
    root: {
        render: function RootWrapper(props: RootProps) {
            return (
                <MainContentLayout>
                    <Root {...props} />
                </MainContentLayout>
            );
        },
        fields: {},
    },
    categories: {
        data: {
            title: "Data",
            components: ["ActionPlan", "ScoreChartBlock"],
        },
        layout: {
            title: "Layout",
            components: ["Separator", "Space", "Grid"],
        },
        interactive: {
            title: "Atoms",
            components: ["Typography"],
        },
        media: {
            title: "Media",
            components: ["Image"],
        },
        content: {
            title: "Content",
            components: ["Greetings", "HeroSection", "ArticlesSection", "IndicatorsSection"],
        },
    },
    components: {
        Image,
        Typography,
        HeroSection,
        ArticlesSection,
        IndicatorsSection,
        Separator,
        Space,
        Grid,
        ScoreChartBlock,
        ActionPlan: ActionPlanBlock,
        Greetings: GreetingsConfig,
    },
};

export default rootConfig;
